<template>
  <section class="statusHead">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <base-breadcrumb :items="breadcrumbItems" />
        </div>
      </div>
      <h3>{{ title }}</h3>
      <div class="row justify-content-between align-items-center">
        <div v-if="showTabs" class="col-auto">
          <nav class="nav filter">
            <a class="nav-link" :class="activeTab === 'ALL' ? 'active' : ''" @click="$emit('all')">
              <i class="fa fa-border-all" />
              <span class="text">Tümü</span>
            </a>
            <a class="nav-link" :class="activeTab === 'DRAFT' ? 'active' : ''" @click="$emit('draft')">
              <i class="fa fa-edit" />
              <span class="text">Taslaklar</span>
            </a>
            <a class="nav-link" :class="activeTab === 'WAITING_APPROVAL' ? 'active' : ''" @click="$emit('waitingApproval')">
              <i class="fa fa-history" />
              <span class="text">Onay Bekleyenler</span>
            </a>
            <!--<a class="nav-link" :class="activeTab === 'DELETED' ? 'active' : ''" @click="$emit('deleted')">-->
            <!--  <i class="fa fa-trash-alt"></i>-->
            <!--  <span class="text">Silinenler</span>-->
            <!--</a>-->
          </nav>
        </div>
        <div v-if="makeVisible" class="col text-right">
          <span :title="canCreateEntity ? null : noPermissionMessage" class="d-inline-block">
            <button
              v-if="dataToggle === '' && dataTarget === ''"
              type="button"
              class="btn btn-primary"
              :disabled="!canCreateEntity"
              @click="$emit('addButton')"
            >
              Ekle
            </button>
            <button
              v-else
              type="button"
              class="btn btn-primary"
              :disabled="!canCreateEntity"
              :data-toggle="dataToggle"
              :data-target="dataTarget"
              @click="$emit('addButton')"
            >
              Ekle
            </button>
          </span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import BaseBreadcrumb from "../element/breadcrumb/BaseBreadcrumb.vue";
import callBreadcrumb from "../../util/callBreadcrumb";
import definitionPagePermissionMixin from "../../mixins/definitionPagePermissionMixin";

export default {
  name: "TitleListNavbar",
  components: { BaseBreadcrumb },
  mixins: [definitionPagePermissionMixin],
  props: {
    /**
     * breadcrumbItems propertysi
     */
    items: {
      type: String,
      default: "",
    },
    /**
     * Başlık
     */
    title: {
      type: String,
      default: "",
    },
    /**
     * Aktif tab
     */
    activeTab: {
      type: String,
      default: "ALL",
    },
    /**
     * data-toggle propertysi example: 'modal'
     */
    dataToggle: {
      type: String,
      default: "",
    },
    /**
     * data-target propert example: #exampleDiv
     */
    dataTarget: {
      type: String,
      default: "",
    },

    makeVisible: {
      type: Boolean,
      default: true,
    },
    showTabs: {
      type: Boolean,
      default: true,
    },
    /**
     * Ekle butonunun açtığı tanımlama sayfası (ör. "/istasyon-tanimlama"). Verilirse buton kullanıcının
     * create yetkisine göre disabled olur.
     */
    definitionPage: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      breadcrumbItems: callBreadcrumb[this.items],
    };
  },
  computed: {
    canCreateEntity() {
      return !this.definitionPage || this.canCreateDefinitionPage(this.definitionPage);
    },
  },
};
</script>

<style scoped></style>
